module.exports = __webpack_public_path__ + "static/logo-w-11cb0d841978ec15e6bd89626e24343f.png";